
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("4qzdE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $351552e1cde3a356$export$2e2bcd8739ae039);

var $bDIb5 = parcelRequire("bDIb5");

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("3avtZ");

var $8Uumt = parcelRequire("8Uumt");

var $jD5no = parcelRequire("jD5no");

var $g99jC = parcelRequire("g99jC");

var $b5ke6 = parcelRequire("b5ke6");

var $9dbF6 = parcelRequire("9dbF6");

var $9NiTW = parcelRequire("9NiTW");

var $l8ruj = parcelRequire("l8ruj");
const $351552e1cde3a356$var$JiraBusinessFormApp = ({ queries: { formQuery: formQuery } })=>{
    const data = (0, $8Uumt.usePreloadedQuery)((0, $bDIb5.default), formQuery);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "business-form-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
        id: "business"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g99jC.ProjectContextProvider), {
        projectFragment: data.jira?.jiraProjectByKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5ke6.FormDirectory), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "core"
    }))));
};
var $351552e1cde3a356$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($351552e1cde3a356$var$JiraBusinessFormApp);

});
parcelRegister("bDIb5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2ddc2b1f4356a3d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3754a133560d3cad44f3683f7d011fba>>
 * @relayHash 8e0b57fc78588fab5ce6e2ba76089a61
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 00dfb7b57058946faf78573ea5754789e6b3e2dd7eab0b5c0a813c3db15e260b

var $eiowN = parcelRequire("eiowN");
const $a2ddc2b1f4356a3d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v2 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "src_jiraBusinessFormQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ProjectContextProvider"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "src_jiraBusinessFormQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "large"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectStyle"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                {
                                    "alias": "assignIssues",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "ASSIGN_ISSUES"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v2 /*: any*/ ,
                                    "storageKey": "action(type:\"ASSIGN_ISSUES\")"
                                },
                                {
                                    "alias": "administerProject",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "EDIT_PROJECT_CONFIG"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v2 /*: any*/ ,
                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                },
                                {
                                    "alias": "createIssues",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "CREATE_ISSUES"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v2 /*: any*/ ,
                                    "storageKey": "action(type:\"CREATE_ISSUES\")"
                                },
                                {
                                    "alias": "deleteIssues",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "DELETE_ISSUES"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v2 /*: any*/ ,
                                    "storageKey": "action(type:\"DELETE_ISSUES\")"
                                },
                                {
                                    "alias": "editIssues",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "EDIT_ISSUES"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v2 /*: any*/ ,
                                    "storageKey": "action(type:\"EDIT_ISSUES\")"
                                },
                                {
                                    "alias": "linkIssues",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "LINK_ISSUES"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v2 /*: any*/ ,
                                    "storageKey": "action(type:\"LINK_ISSUES\")"
                                },
                                {
                                    "alias": "scheduleIssues",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "SCHEDULE_ISSUES"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v2 /*: any*/ ,
                                    "storageKey": "action(type:\"SCHEDULE_ISSUES\")"
                                },
                                {
                                    "alias": "transitionIssues",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "TRANSITION_ISSUES"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v2 /*: any*/ ,
                                    "storageKey": "action(type:\"TRANSITION_ISSUES\")"
                                },
                                {
                                    "alias": "viewIssues",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "VIEW_ISSUES"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v2 /*: any*/ ,
                                    "storageKey": "action(type:\"VIEW_ISSUES\")"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "00dfb7b57058946faf78573ea5754789e6b3e2dd7eab0b5c0a813c3db15e260b",
            "metadata": {},
            "name": "src_jiraBusinessFormQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a2ddc2b1f4356a3d$var$node.hash = "4a44486d377d3a1bdfddc09fee9e13d1";
(0, $eiowN.PreloadableQueryRegistry).set($a2ddc2b1f4356a3d$var$node.params.id, $a2ddc2b1f4356a3d$var$node);
var $a2ddc2b1f4356a3d$export$2e2bcd8739ae039 = $a2ddc2b1f4356a3d$var$node;

});

parcelRegister("g99jC", function(module, exports) {

$parcel$export(module.exports, "ProjectContextProvider", () => $c897bf0612de228a$export$a85f6b5857d2176);

var $g6hRl = parcelRequire("g6hRl");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $12jwF = parcelRequire("12jwF");

var $54qG5 = parcelRequire("54qG5");

var $5YBrl = parcelRequire("5YBrl");

var $1Zr0i = parcelRequire("1Zr0i");

var $daQYX = parcelRequire("daQYX");

var $cm8b5 = parcelRequire("cm8b5");

var $gxGcZ = parcelRequire("gxGcZ");

var $iXVV6 = parcelRequire("iXVV6");

var $lVJAU = parcelRequire("lVJAU");

var $k7McJ = parcelRequire("k7McJ");

var $8OqLl = parcelRequire("8OqLl");
const $c897bf0612de228a$export$a85f6b5857d2176 = ({ children: children, projectFragment: projectFragment = null })=>{
    const { replace: replace } = (0, $lVJAU.useRouterActions)();
    const projectData = (0, $8Uumt.useFragment)((0, $g6hRl.default), projectFragment);
    const project = (0, $5uXOq.useMemo)(()=>projectData ? {
            id: Number(projectData.projectId),
            key: projectData.key,
            avatarUrl: projectData.avatar.large,
            name: projectData.name,
            type: projectData.projectType.toLowerCase(),
            isSimplified: projectData.projectStyle === 'TEAM_MANAGED_PROJECT',
            isFavorite: projectData.isFavourite,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            status: projectData.status,
            permissions: {
                assignIssues: projectData.assignIssues.canPerform,
                administerProject: projectData.administerProject.canPerform,
                createIssues: projectData.createIssues.canPerform,
                deleteIssues: projectData.deleteIssues.canPerform,
                editIssues: projectData.editIssues.canPerform,
                linkIssues: projectData.linkIssues.canPerform,
                scheduleIssues: projectData.scheduleIssues.canPerform,
                transitionIssues: projectData.transitionIssues.canPerform,
                viewIssues: projectData.viewIssues.canPerform
            }
        } : null, [
        projectData
    ]);
    const jqlContext = projectData ? `project = '${projectData.key}'` : '';
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            projectId: Number(projectData?.projectId),
            isTeamManaged: projectData?.projectStyle === 'TEAM_MANAGED_PROJECT',
            projectType: projectData?.projectType.toLowerCase()
        }), [
        projectData
    ]);
    const entityData = (0, $5uXOq.useMemo)(()=>projectData?.viewIssues.canPerform ? {
            name: projectData.name,
            id: String(projectData.projectId)
        } : null, [
        projectData
    ]);
    const projects = (0, $5uXOq.useMemo)(()=>project ? [
            project
        ] : undefined, [
        project
    ]);
    const projectIdList = (0, $5uXOq.useMemo)(()=>projectData ? [
            Number(projectData.projectId)
        ] : undefined, [
        projectData
    ]);
    if (projectData?.status === 'ARCHIVED') {
        replace('/jira/errors/project-archived');
        return null;
    }
    let content;
    if (projectData == null || project == null || entityData == null) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8OqLl.default), null);
    else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daQYX.ProjectHookProvider), {
        project: project
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $54qG5.BusinessEntityProvider), {
        data: entityData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Zr0i.RealtimeProvider), {
        ids: projectIdList
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $12jwF.AriProvider), {
        ari: projectData.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5YBrl.JqlProvider), {
        jqlContext: jqlContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gxGcZ.FiltersProvider), {
        projects: projects
    }, children)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceSuccess), {
        experience: (0, $k7McJ.FETCH_PROJECT_EXPERIENCE)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        containerId: projectData?.projectId,
        containerType: "project",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "businessProjectContext",
        attributes: analyticsAttributes,
        // we set a key on the first element to force React to re-render when the context changes
        // to avoid query race-conditions that would lead to promises from a previous context
        // resolving in the current context view, and thus seeing unrelated data
        key: projectData?.projectId
    }, content);
};

});
parcelRegister("g6hRl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca223f7fcde9b08b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f2fac8fffa8442fe537760fd97524aa5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ca223f7fcde9b08b$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "canPerform"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ProjectContextProvider",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "key"
                },
                "action": "THROW",
                "path": "key"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "projectId"
                },
                "action": "THROW",
                "path": "projectId"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "large"
                            },
                            "action": "THROW",
                            "path": "avatar.large"
                        }
                    ]
                },
                "action": "THROW",
                "path": "avatar"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "name"
                },
                "action": "THROW",
                "path": "name"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "projectType"
                },
                "action": "THROW",
                "path": "projectType"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "status"
                },
                "action": "THROW",
                "path": "status"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "projectStyle"
                },
                "action": "THROW",
                "path": "projectStyle"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                },
                "action": "THROW",
                "path": "isFavourite"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "assignIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "ASSIGN_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "assignIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"ASSIGN_ISSUES\")"
                },
                "action": "THROW",
                "path": "assignIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "administerProject",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "EDIT_PROJECT_CONFIG"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "administerProject.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                },
                "action": "THROW",
                "path": "administerProject"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "createIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "CREATE_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "createIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"CREATE_ISSUES\")"
                },
                "action": "THROW",
                "path": "createIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "deleteIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "DELETE_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "deleteIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"DELETE_ISSUES\")"
                },
                "action": "THROW",
                "path": "deleteIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "editIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "EDIT_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "editIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"EDIT_ISSUES\")"
                },
                "action": "THROW",
                "path": "editIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "linkIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "LINK_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "linkIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"LINK_ISSUES\")"
                },
                "action": "THROW",
                "path": "linkIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "scheduleIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "SCHEDULE_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "scheduleIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"SCHEDULE_ISSUES\")"
                },
                "action": "THROW",
                "path": "scheduleIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "transitionIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "TRANSITION_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "transitionIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"TRANSITION_ISSUES\")"
                },
                "action": "THROW",
                "path": "transitionIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "viewIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "VIEW_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "viewIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"VIEW_ISSUES\")"
                },
                "action": "THROW",
                "path": "viewIssues"
            }
        ],
        "type": "JiraProject"
    };
}();
$ca223f7fcde9b08b$var$node.hash = "b80353b73daa33fbcfe6685edf0b4639";
var $ca223f7fcde9b08b$export$2e2bcd8739ae039 = $ca223f7fcde9b08b$var$node;

});

parcelRegister("12jwF", function(module, exports) {

$parcel$export(module.exports, "AriProvider", () => $d9a27a44a6301e03$export$c806f8ac05dc61fa);
$parcel$export(module.exports, "useEntityAri", () => $d9a27a44a6301e03$export$badcacdc306567b8);

var $5uXOq = parcelRequire("5uXOq");
const $d9a27a44a6301e03$var$AriContext = /*#__PURE__*/ (0, $5uXOq.createContext)('');
const $d9a27a44a6301e03$export$c806f8ac05dc61fa = ({ ari: ari, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9a27a44a6301e03$var$AriContext.Provider, {
        value: ari
    }, children);
const $d9a27a44a6301e03$export$badcacdc306567b8 = ()=>(0, $5uXOq.useContext)($d9a27a44a6301e03$var$AriContext);

});

parcelRegister("54qG5", function(module, exports) {

$parcel$export(module.exports, "BusinessEntityProvider", () => $a71d927d8f07dfcc$export$c800e064c3c327ef);
$parcel$export(module.exports, "useBusinessEntity", () => $a71d927d8f07dfcc$export$ff2574b00bc1c100);

var $5uXOq = parcelRequire("5uXOq");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $a71d927d8f07dfcc$var$BusinessEntityContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $a71d927d8f07dfcc$export$c800e064c3c327ef = ({ data: data, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a71d927d8f07dfcc$var$BusinessEntityContext.Provider, {
        value: data
    }, children);
const $a71d927d8f07dfcc$export$ff2574b00bc1c100 = ()=>{
    const entity = (0, $5uXOq.useContext)($a71d927d8f07dfcc$var$BusinessEntityContext);
    return {
        data: entity
    };
};

});

parcelRegister("5YBrl", function(module, exports) {

$parcel$export(module.exports, "JqlProvider", () => $81e54c5b62a4ab4d$export$fdc879e2ba0da048);
$parcel$export(module.exports, "useJqlContext", () => $81e54c5b62a4ab4d$export$f32e2f688fc08561);

var $5uXOq = parcelRequire("5uXOq");
const $81e54c5b62a4ab4d$var$JqlContext = /*#__PURE__*/ (0, $5uXOq.createContext)('');
const $81e54c5b62a4ab4d$export$fdc879e2ba0da048 = ({ jqlContext: jqlContext, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($81e54c5b62a4ab4d$var$JqlContext.Provider, {
        value: jqlContext
    }, children);
const $81e54c5b62a4ab4d$export$f32e2f688fc08561 = ()=>(0, $5uXOq.useContext)($81e54c5b62a4ab4d$var$JqlContext);

});

parcelRegister("1Zr0i", function(module, exports) {

$parcel$export(module.exports, "RealtimeProvider", () => $6a65786548fb921c$export$64d242981d970821);
$parcel$export(module.exports, "useRealtimeContext", () => $6a65786548fb921c$export$f39c07717ad8c35b);

var $5uXOq = parcelRequire("5uXOq");
const $6a65786548fb921c$var$RealtimeContext = /*#__PURE__*/ (0, $5uXOq.createContext)([]);
const $6a65786548fb921c$export$64d242981d970821 = ({ ids: ids, children: children })=>{
    const projectsIds = (0, $5uXOq.useMemo)(()=>ids ? ids.map((pid)=>String(pid)) : [], [
        ids
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6a65786548fb921c$var$RealtimeContext.Provider, {
        value: projectsIds
    }, children);
};
const $6a65786548fb921c$export$f39c07717ad8c35b = ()=>(0, $5uXOq.useContext)($6a65786548fb921c$var$RealtimeContext);

});

parcelRegister("daQYX", function(module, exports) {

$parcel$export(module.exports, "ProjectHookProvider", () => $cf7f84dff81db95f$export$f1938a4916a14d9f);
$parcel$export(module.exports, "useProject", () => $cf7f84dff81db95f$export$51b1383ef8844a7);

var $5uXOq = parcelRequire("5uXOq");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $cf7f84dff81db95f$var$Context = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $cf7f84dff81db95f$export$f1938a4916a14d9f = ({ project: project, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cf7f84dff81db95f$var$Context.Provider, {
        value: project
    }, children);
const $cf7f84dff81db95f$export$51b1383ef8844a7 = ()=>{
    const project = (0, $5uXOq.useContext)($cf7f84dff81db95f$var$Context);
    if (!project) throw new Error('useProject must be used within a ProjectHookProvider');
    return project;
};

});

parcelRegister("gxGcZ", function(module, exports) {

$parcel$export(module.exports, "FiltersProvider", () => $5ac2d1f4676106ae$export$905df3588d1d8c75);
$parcel$export(module.exports, "useAssigneesFilterQuery", () => $5ac2d1f4676106ae$export$f39bce8705b01ff5);
$parcel$export(module.exports, "useProjectFilter", () => $5ac2d1f4676106ae$export$b71768ffb8163578);
$parcel$export(module.exports, "useAllowedFieldTypes", () => $5ac2d1f4676106ae$export$9dc8a291956c2fa9);

var $5uXOq = parcelRequire("5uXOq");

var $5fc53 = parcelRequire("5fc53");

var $gzkAf = parcelRequire("gzkAf");
const $5ac2d1f4676106ae$var$DEFAULT_VALUE = {
    assigneeQuery: '',
    projectFilter: {
        totalCount: 0,
        options: []
    }
};
const $5ac2d1f4676106ae$var$FiltersContext = /*#__PURE__*/ (0, $5uXOq.createContext)($5ac2d1f4676106ae$var$DEFAULT_VALUE);
const $5ac2d1f4676106ae$export$905df3588d1d8c75 = ({ projects: projects, children: children })=>{
    const value = (0, $5uXOq.useMemo)(()=>{
        if (!projects) return $5ac2d1f4676106ae$var$DEFAULT_VALUE;
        const assigneeQuery = `is assignee of (${projects.map((project)=>project.key).join(', ')})`;
        const projectFilter = {
            totalCount: projects.length,
            options: projects.map((project)=>({
                    label: project.name,
                    value: String(project.id),
                    avatar: project.avatarUrl,
                    square: true
                }))
        };
        return {
            assigneeQuery: assigneeQuery,
            projectFilter: projectFilter
        };
    }, [
        projects
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ac2d1f4676106ae$var$FiltersContext.Provider, {
        value: value
    }, children);
};
const $5ac2d1f4676106ae$export$f39bce8705b01ff5 = ()=>(0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext).assigneeQuery;
const $5ac2d1f4676106ae$export$b71768ffb8163578 = ()=>(0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext).projectFilter;
const $5ac2d1f4676106ae$export$9dc8a291956c2fa9 = (inputAllowedFieldTypes)=>{
    const filtersContext = (0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext);
    return (0, $5uXOq.useMemo)(()=>{
        const result = new Set(inputAllowedFieldTypes ?? (0, $gzkAf.BUSINESS_FIELD_TYPES));
        if (filtersContext.projectFilter.totalCount <= 1) result.delete((0, $5fc53.PROJECT_TYPE));
        return result;
    }, [
        filtersContext,
        inputAllowedFieldTypes
    ]);
};

});
parcelRegister("gzkAf", function(module, exports) {

$parcel$export(module.exports, "POPUP_WIDTH", () => $92b04c6ea9a59b67$export$b6d617db656efcca);
$parcel$export(module.exports, "SHOW_MORE_OPTIONS_BTN_SIZE", () => $92b04c6ea9a59b67$export$dd535f74d98d8b3);
$parcel$export(module.exports, "OPTIONS_AVAILABLE_WIDTH", () => $92b04c6ea9a59b67$export$dba112976ea61483);
$parcel$export(module.exports, "GAP_BETWEEN_OPTION", () => $92b04c6ea9a59b67$export$fe1082abeeda69ed);
$parcel$export(module.exports, "OPTION_SPAN_PADDING", () => $92b04c6ea9a59b67$export$17ed91292eb6c163);
$parcel$export(module.exports, "POPUP_OFFSET_TOP", () => $92b04c6ea9a59b67$export$15839778e99d81e7);
$parcel$export(module.exports, "OPTION_MAX_WIDTH", () => $92b04c6ea9a59b67$export$39aa3a14ebf850c7);
$parcel$export(module.exports, "DATE_RANGE_TYPE", () => $92b04c6ea9a59b67$export$1178808c606e043b);
$parcel$export(module.exports, "BUSINESS_FIELD_TYPES", () => $92b04c6ea9a59b67$export$c269ba5d631cb115);
$parcel$export(module.exports, "SOFTWARE_FIELD_TYPES", () => $92b04c6ea9a59b67$export$232814e45256d5dc);
$parcel$export(module.exports, "IMPLEMENTED_TYPES", () => $92b04c6ea9a59b67$export$9615a3d79408a88a);
$parcel$export(module.exports, "EXTRA_CUSTOM_FIELD_TYPES", () => $92b04c6ea9a59b67$export$a21166a4b76932b5);
$parcel$export(module.exports, "SAVED_FILTERS_PER_PAGE", () => $92b04c6ea9a59b67$export$1989c7236a398e8a);

var $gwIPs = parcelRequire("gwIPs");

var $5fc53 = parcelRequire("5fc53");
const $92b04c6ea9a59b67$export$b6d617db656efcca = 360;
const $92b04c6ea9a59b67$export$90bfd0dcc25478e1 = (0, $gwIPs.gridSize) * 2.5;
const $92b04c6ea9a59b67$export$dd535f74d98d8b3 = 32;
const $92b04c6ea9a59b67$export$dba112976ea61483 = $92b04c6ea9a59b67$export$b6d617db656efcca - $92b04c6ea9a59b67$export$90bfd0dcc25478e1 * 2;
const $92b04c6ea9a59b67$export$fe1082abeeda69ed = (0, $gwIPs.gridSize) / 2;
const $92b04c6ea9a59b67$export$17ed91292eb6c163 = (0, $gwIPs.gridSize) * 2;
const $92b04c6ea9a59b67$export$15839778e99d81e7 = 215;
const $92b04c6ea9a59b67$export$de3cbeaaf9d2669 = 28;
const $92b04c6ea9a59b67$export$39aa3a14ebf850c7 = 150;
const $92b04c6ea9a59b67$export$1178808c606e043b = 'dateRange';
const $92b04c6ea9a59b67$export$c269ba5d631cb115 = [
    (0, $5fc53.ASSIGNEE_TYPE),
    (0, $5fc53.CATEGORY_TYPE),
    (0, $5fc53.COMPONENTS_TYPE),
    (0, $5fc53.CREATED),
    $92b04c6ea9a59b67$export$1178808c606e043b,
    (0, $5fc53.ISSUE_TYPE),
    (0, $5fc53.LABELS_TYPE),
    (0, $5fc53.PRIORITY_TYPE),
    (0, $5fc53.PROJECT_TYPE),
    (0, $5fc53.REPORTER_TYPE),
    (0, $5fc53.STATUS_TYPE),
    (0, $5fc53.UPDATED),
    (0, $5fc53.USER_CF_TYPE),
    (0, $5fc53.SELECT_CF_TYPE),
    (0, $5fc53.MULTI_SELECT_CF_TYPE),
    (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
    (0, $5fc53.PEOPLE_CF_TYPE),
    (0, $5fc53.DATE_CF_TYPE),
    (0, $5fc53.GOALS_CF_TYPE),
    (0, $5fc53.TEAMS_PLATFORM_CF_TYPE),
    (0, $5fc53.PARENT_FIELD_TYPE)
];
const $92b04c6ea9a59b67$export$232814e45256d5dc = [
    (0, $5fc53.SPRINT_TYPE),
    (0, $5fc53.FIX_VERSIONS_TYPE)
];
const $92b04c6ea9a59b67$export$9615a3d79408a88a = new Set([
    ...$92b04c6ea9a59b67$export$c269ba5d631cb115,
    ...$92b04c6ea9a59b67$export$232814e45256d5dc
]);
const $92b04c6ea9a59b67$export$a21166a4b76932b5 = new Set([
    (0, $5fc53.USER_CF_TYPE),
    (0, $5fc53.SELECT_CF_TYPE),
    (0, $5fc53.MULTI_SELECT_CF_TYPE),
    (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
    (0, $5fc53.PEOPLE_CF_TYPE),
    (0, $5fc53.DATE_CF_TYPE)
]);
const $92b04c6ea9a59b67$export$6a2e733db5135f27 = (0, $gwIPs.gridSize) * 3.5;
const $92b04c6ea9a59b67$export$1989c7236a398e8a = 50;
const $92b04c6ea9a59b67$export$91fc9d65fca142a3 = 'users';
const $92b04c6ea9a59b67$export$d74c70f8fb216c6b = 'recentlyUsedUsers';

});


// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("k7McJ", function(module, exports) {

$parcel$export(module.exports, "FETCH_PROJECT_EXPERIENCE", () => $47951bf9c4bef1f5$export$cb40bbf7ea51db63);
const $47951bf9c4bef1f5$export$cb40bbf7ea51db63 = {
    experience: 'fetch-project',
    packageName: 'jiraBusinessEntityProjectProvider',
    teamName: 'wanjel'
};

});

parcelRegister("8OqLl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5cc2e237e9a9763$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $a5cc2e237e9a9763$var$NotFoundComponent = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("dDX2b")), {
    moduleId: "./src/packages/business/entity/project-provider/src/ui/project-context/not-found/main.tsx"
});
const $a5cc2e237e9a9763$var$NotFoundAsync = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "not-found-component",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a5cc2e237e9a9763$var$NotFoundComponent, null));
var $a5cc2e237e9a9763$export$2e2bcd8739ae039 = $a5cc2e237e9a9763$var$NotFoundAsync;

});
parcelRegister("dDX2b", function(module, exports) {

let $9eecb5dea26f1017$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9eecb5dea26f1017$var$load("gUneV").then(()=>parcelRequire('4zX1V'));

});



parcelRegister("b5ke6", function(module, exports) {

$parcel$export(module.exports, "FormDirectory", () => $62e53b83a5e1446e$export$e0aa058f1221261);

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $62e53b83a5e1446e$export$e0aa058f1221261 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cjldq")), {
    moduleId: "./src/packages/business/form/src/ui/form-directory/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$62e53b83a5e1446e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "form-directory",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($62e53b83a5e1446e$export$e0aa058f1221261, null));

});
parcelRegister("cjldq", function(module, exports) {

let $8f67b7585cd261cc$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8f67b7585cd261cc$var$load("ffQaD"),
    $8f67b7585cd261cc$var$load("kvRbA"),
    $8f67b7585cd261cc$var$load("fliVL"),
    $8f67b7585cd261cc$var$load("4iLb7")
]).then(()=>parcelRequire('6nfLj'));

});


parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $2YZCu = parcelRequire("2YZCu");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $2YZCu.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});




//# sourceMappingURL=async-business-form-entrypoint.60060b8e.js.map
